/**
 * Project - fasthelp5.fa2chat-product
 *
 * @desc チャット関連の定数クラス
 *
 * @author jimu
 * @copyright Copyright 2018 TechMatrix Corporation, Inc. All rights reserved.
 */

export default class {
  /**
   * 生年月日選択リストの年 : Start
   */
  static get BIRTHDAY_YEAR_START() {
    return '1900'
  }
}



// WEBPACK FOOTER //
// ./src/constants/ChatConst.js